export default __webpack_public_path__ + "static/media/navicon.3e9672e2.svg";